import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

Swiper.use( [ Navigation, Pagination, Autoplay ] );

const swiperFV = new Swiper( '.swiper-fv', {
	centeredSlides: true,
	initialSlide: 0,
	loop: true,
	breakpoints: {
		0: {
			slidesPerView: 1.1,
			spaceBetween: 14,
		},
		768: {
			slidesPerView: 'auto',
			spaceBetween: 0,
		},
	},
} );

const swiperSimpleList = document.querySelectorAll( '.swiper-simple' );

swiperSimpleList.forEach( ( swiperEl ) => {
	new Swiper( swiperEl, {
		centeredSlides: true,
		initialSlide: 0,
		spaceBetween: 0,

		pagination: {
			el: swiperEl.querySelector( '.swiper-simple-pagination' ),
			clickable: true,
		},

		navigation: {
			nextEl: swiperEl.querySelector( '.swiper-simple-button-next' ),
			prevEl: swiperEl.querySelector( '.swiper-simple-button-prev' ),
		},

		breakpoints: {
			0: {
				slidesPerView: 2.25,
				centeredSlides: true,
				spaceBetween: 20,
			},
			768: {
				slidesPerView: 'auto',
				centeredSlides: false,
				spaceBetween: 0,
			},
		},
	} );
} );

const swiperMeetup = new Swiper( '.swiper-meetup', {
	centeredSlides: true,
	loop: true,
	pagination: {
		el: '.swiper-pagination',
	},

	navigation: {
		nextEl: '.swiper-meetup-button-next',
		prevEl: '.swiper-meetup-button-prev',
		addIcons: false,
	},

	breakpoints: {
		0: {
			slidesPerView: 1.1,
			spaceBetween: 10,
		},
		768: {
			slidesPerView: 'auto',
			spaceBetween: 60,
		},
	},
} );
